<base-site-layout [heading]="'Rechnungen' | translate" headerIcon="iim iim-invoice">
    <base-site-layout-action>
        <button class="btn btn-primary ms-1 d-inline-block" routerLink="/client/my-admin/invoice/create/standalone">
            <em class="fas fa-plus"></em>
            {{ 'Rechnung erfassen' | translate }}
        </button>
    </base-site-layout-action>
    <div class="col mb-3">
        <iim-pagination
            [pagination]="store.pagination().toDto()"
            [translations]="paginationTranslations"
            (paginationChanged)="paginationChanged($event)"
        >
            <div class="row">
                <div class="col pe-4">
                    <iim-table
                        theme="material"
                        [headerSticky]="true"
                        [tableHeaders]="header"
                        [tableContent]="tableContent"
                        [tableActions]="actions"
                        [tableInfo]="infoRow"
                        [filtersActive]="true"
                        [hideTable]="store.invoices().length === 0"
                        (filterClosed)="filterChanged$.next()"
                        (onSort)="onSortChange($event)"
                    >
                        <ng-template #infoRow>
                            <iim-table-filter-date-range
                                xlClass="col-xl-1"
                                [label]="'Rechnungsdatum' | translate"
                                [placeholderFrom]="'Rechnungsdatum' | translate"
                                [placeholderTo]="'Rechnungsdatum' | translate"
                                [fromLabel]="'Von' | translate"
                                [toLabel]="'Bis' | translate"
                                [value]="store.filter().documentDateRange"
                                (valueChange)="store.setDocumentDateRange($event); filterChanged$.next()"
                            ></iim-table-filter-date-range>
                            <iim-table-filter-date-range
                                xlClass="col-xl-1"
                                [label]="'Erstellungsdatum' | translate"
                                [placeholderFrom]="'Erstellungsdatum' | translate"
                                [placeholderTo]="'Erstellungsdatum' | translate"
                                [fromLabel]="'Von' | translate"
                                [toLabel]="'Bis' | translate"
                                [value]="store.filter().createDateRange"
                                (valueChange)="store.setCreateDateRange($event); filterChanged$.next()"
                            ></iim-table-filter-date-range>
                        </ng-template>
                        <ng-template #header>
                            <iim-table-header-column
                                name="Buchungsdatum"
                                xlClass="col-xl-2"
                                sortingHeaderName="createDate"
                            >
                                {{ 'Buchung' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column
                                name="Rechnungsdatum"
                                xlClass="col-xl-1"
                                sortingHeaderName="documentDate"
                            >
                                {{ 'Rg.-Datum' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="Lieferant" xlClass="col-xl-2">
                                {{ 'Lieferant' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="Nummer" xlClass="col-xl-2">
                                {{ 'Nummer' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="Status" xlClass="col-xl-2">
                                {{ 'Status' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="Wert" xlClass="col-xl-2" [alignRight]="true">
                                {{ 'Wert' | translate }}
                            </iim-table-header-column>
                            <iim-table-header-column name="ACTION" [alignRight]="true" xlClass="col-xl-1">
                                {{ 'Aktion' | translate }}
                            </iim-table-header-column>
                        </ng-template>
                        <iim-table-filter-preview-entry
                            [label]="'Rechnungsdatum' | translate"
                            [content]="
                                store.filter().documentDateRange
                                    | formatDateRange: ('ab' | translate) : ('bis' | translate)
                            "
                            (removed)="store.resetDocumentDateFilter(); filterChanged$.next()"
                        ></iim-table-filter-preview-entry>
                        <iim-table-filter-preview-entry
                            [label]="'Erstellungsdatum' | translate"
                            [content]="
                                store.filter().createDateRange
                                    | formatDateRange: ('ab' | translate) : ('bis' | translate)
                            "
                            (removed)="store.resetCreateDateFilter(); filterChanged$.next()"
                        ></iim-table-filter-preview-entry>
                        <ng-template #actions>
                            <div class="col-md-auto col-sm-12 my-1 my-md-0 my-lg-0 my-xl-0 p-0">
                                <div class="row justify-content-end g-1">
                                    <div class="col-md-auto col-sm-12 mb-1 mb-md-0">
                                        <div class="input-group">
                                            <span class="input-group-text"><em class="fas fa-search"></em></span>
                                            <input
                                                type="text"
                                                class="form-control"
                                                [placeholder]="'Suche' | translate"
                                                [ngModel]="store.filter().generalSearch"
                                                (ngModelChange)="store.setGeneralSearch($event); filterChanged$.next()"
                                            />
                                            @if (store.filter().generalSearch) {
                                                <span
                                                    class="input-group-text cursor-pointer"
                                                    (click)="store.setGeneralSearch(''); filterChanged$.next()"
                                                >
                                                    <em class="fas fa-trash"></em>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div class="col-md-auto col-sm-12">
                                        <div class="input-group">
                                            <select
                                                class="form-select"
                                                [ngModel]="store.filter().status"
                                                (ngModelChange)="store.setStatus($event); filterChanged$.next()"
                                            >
                                                <option [value]="ListInvoiceStatus.ALL">
                                                    {{ 'Alle' | translate }}
                                                </option>
                                                <option [value]="ListInvoiceStatus.UNAPPROVED">
                                                    {{ 'freizugeben' | translate }}
                                                </option>
                                                <option [value]="ListInvoiceStatus.APPROVED">
                                                    {{ 'freigegeben' | translate }}
                                                </option>
                                                <option [value]="ListInvoiceStatus.REJECTED">
                                                    {{ 'abgelehnt' | translate }}
                                                </option>
                                                <option [value]="ListInvoiceStatus.CANCELED">
                                                    {{ 'storniert' | translate }}
                                                </option>
                                                <option [value]="ListInvoiceStatus.PAID">
                                                    {{ 'bezahlt' | translate }}
                                                </option>
                                                <option [value]="ListInvoiceStatus.CREATED">
                                                    {{ 'erstellt' | translate }}
                                                </option>
                                                <option [value]="ListInvoiceStatus.DRAFT">
                                                    {{ 'im Entwurf' | translate }}
                                                </option>
                                            </select>
                                            @if (store.filter().status !== ListInvoiceStatus.ALL) {
                                                <span
                                                    class="input-group-text cursor-pointer"
                                                    (click)="
                                                        store.setStatus(ListInvoiceStatus.ALL); filterChanged$.next()
                                                    "
                                                >
                                                    <em class="fas fa-trash"></em>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </ng-template>
                        <ng-template #tableContent>
                            @for (invoice of store.invoices(); track invoice.id) {
                                <iim-table-row (expandChange)="expandChange(invoice, $event)">
                                    <ng-template iimTableRowExpandable>
                                        <invoice-list-preview [invoice]="invoice"></invoice-list-preview>
                                    </ng-template>
                                    <iim-table-column name="Buchungsdatum" xlClass="col-xl-2">
                                        @if (invoice.bookingDate) {
                                            {{ invoice.bookingDate | dayjs: 'L LT' }}
                                        } @else {
                                            <i>-</i>
                                        }
                                    </iim-table-column>
                                    <iim-table-column name="Rechnungsdatum" xlClass="col-xl-1">
                                        @if (invoice.documentDate) {
                                            {{ invoice.documentDate | dayjs: 'L' }}
                                        } @else {
                                            <i>-</i>
                                        }
                                    </iim-table-column>
                                    <iim-table-column name="Lieferant" xlClass="col-xl-2">
                                        @if (invoice.supplierName) {
                                            <span
                                                [innerHtml]="
                                                    (invoice.supplierName
                                                        | supplierDisplayName: invoice.supplierNumber)
                                                        | highlight: store.filter().generalSearch
                                                "
                                            ></span>
                                        } @else {
                                            <i>-</i>
                                        }
                                    </iim-table-column>
                                    <iim-table-column name="Nummer" xlClass="col-xl-2">
                                        @if (invoice.invoiceNumber) {
                                            @if (invoice.numberOfFiles > 0) {
                                                <em class="fas fa-paperclip pe-1"></em>
                                            }
                                            <span
                                                copyToClipboard
                                                [innerHtml]="
                                                    invoice.invoiceNumber | highlight: store.filter().generalSearch
                                                "
                                            ></span>
                                        } @else {
                                            <i>-</i>
                                        }
                                    </iim-table-column>
                                    <iim-table-column name="Status" xlClass="col-xl-2">
                                        <app-invoice-status-display
                                            [statusId]="invoice.status"
                                        ></app-invoice-status-display>
                                        @if (invoice.linkedOrders > 0) {
                                            <em
                                                class="fas fa-link ps-1"
                                                [matTooltip]="
                                                    'Verknüpfung zu Bestellungen: \{\{count\}\}'
                                                        | translate: { count: invoice.linkedOrders }
                                                "
                                            ></em>
                                        }
                                        @if (invoice.isCreditNote) {
                                            <span
                                                class="badge rounded-pill bg-info-subtle text-info-emphasis ms-1 credit-note-badge"
                                            >
                                                {{ 'Gutschrift' | translate }}
                                            </span>
                                        }
                                    </iim-table-column>
                                    <iim-table-column name="Wert" xlClass="col-xl-2" [alignRight]="true">
                                        <div>
                                            @if (invoice.netAmount !== null && invoice.currency !== null) {
                                                <display-currency [value]="invoice.netAmount" [currencyCode]="invoice.currency" />
                                            } @else {
                                                <i>-</i>
                                            }
                                        </div>
                                    </iim-table-column>
                                    <iim-table-column name="ACTION" xlClass="col-xl-1" [alignRight]="true">
                                        <div class="btn-group-vertical">
                                            <button
                                                class="btn btn-outline-dark btn-sm action-btn"
                                                [routerLink]="'/client/my-admin/invoice/' + invoice.id + '/detail'"
                                                (click)="$event.stopPropagation()"
                                            >
                                                <em class="fas fa-eye pe-1"></em>
                                                {{ 'Detail' | translate }}
                                            </button>
                                        </div>
                                    </iim-table-column>
                                </iim-table-row>
                            }
                        </ng-template>
                    </iim-table>
                    @if (store.invoices()?.length === 0) {
                        <div class="row justify-content-center">
                            <div class="col-auto">
                                <div class="alert alert-info">
                                    {{ 'Keine Rechnungen gefunden' | translate }}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </iim-pagination>
    </div>
</base-site-layout>
